import React from "react";

const RESTIntro = () => {
    return (
        <div className="doc_page_cont">
            <p className="doc_page_cont_title">REST-API</p>

            <p className="doc_page_cont_paragraph">
                In <strong>ErioonDB</strong>, database interactions revolve around the standard CRUD operations — 
                <strong> Create, Read, Update,</strong> and <strong>Delete</strong>. 
                These operations are exposed through simple, secure API endpoints designed for maximum performance and flexibility.
            </p>

            <p className="doc_page_cont_subtitle">Available Operations</p>
            <ul className="list_cont_doc">
                <li><strong>insert_one:</strong> Insert a single document into a collection (<a href="https://www.erioon.com/dev-docs/insert_one" className="text-blue-400">see insert_one</a>)</li>
                <li><strong>insert_many:</strong> Insert multiple documents in one batch operation (<a href="https://www.erioon.com/dev-docs/insert_many" className="text-blue-400">see insert_many</a>)</li>
                <li><strong>get_all:</strong> Retrieve all documents from a collection (<a href="https://www.erioon.com/dev-docs/get_all" className="text-blue-400">see get_all</a>)</li>
                <li><strong>get_specific:</strong> Retrieve specific documents based on a query (<a href="https://www.erioon.com/dev-docs/get_specific" className="text-blue-400">see get_specific</a>)</li>
                <li><strong>delete_one:</strong> Delete a single document matching a condition (<a href="https://www.erioon.com/dev-docs/delete_one" className="text-blue-400">see delete_one</a>)</li>
                <li><strong>delete_many:</strong> Delete multiple documents matching a query (<a href="https://www.erioon.com/dev-docs/delete_many" className="text-blue-400">see delete_many</a>)</li>
                <li><strong>update_query:</strong> Update specific fields of documents matching a query (<a href="https://www.erioon.com/dev-docs/update_query" className="text-blue-400">see update_query</a>)</li>
            </ul>

            <p className="doc_page_cont_subtitle">HTTP Methods Mapping</p>
            <ul className="list_cont_doc">
                <li><strong>POST</strong> — Used for <code>insert_one</code> and <code>insert_many</code></li>
                <li><strong>GET</strong> — Used for <code>get_all</code> and <code>get_specific</code></li>
                <li><strong>PATCH</strong> — Used for <code>update_query</code></li>
                <li><strong>DELETE</strong> — Used for <code>delete_one</code> and <code>delete_many</code></li>
            </ul>

            <p className="doc_page_cont_paragraph">
                In the following sections, we'll break down how to perform each operation with clear examples and best practices, using your API credentials.
            </p>
        </div>
    );
};

export default RESTIntro;
